import { memo, useCallback } from 'react'
import { Button } from '@cocoonspace/ui/components/button'
import { cn } from '@cocoonspace/ui/lib/utils'
import { useLingui } from '@lingui/react/macro'

import { mapEmitter } from '~/domains/search/emitters/search.emitters'
import { useSearchSpaces } from '~/domains/search/hooks/use-search-spaces.hook'

const NoResults = () => {
	const { t } = useLingui()

	return (
		<>
			<h1 className='max-w-[400px] text-4xl font-bold'>
				{t`Tous nos espaces sont réservés sur ce créneau`}
			</h1>

			<p>{t`👇 Mais si vous êtes flexible, nous avons des espaces pour vous`}</p>
		</>
	)
}

const ResetSearch = () => {
	const { t } = useLingui()

	const { isMapVisible, setIsMapVisible, setFilters } = useSearchSpaces()

	const onResetSearch = useCallback(() => {
		setFilters({
			capacity: null,
			day: null,
			end: null,
			features: null,
			latitude: null,
			longitude: null,
			ne_latitude: null,
			ne_longitude: null,
			start: null,
			sw_latitude: null,
			sw_longitude: null,
			text: null,
		})

		if (!isMapVisible) {
			setIsMapVisible(true)
		} else {
			mapEmitter.emit('map.resetToZone')
			mapEmitter.emit('map.fitBounds')
		}
	}, [setFilters, isMapVisible, setIsMapVisible])

	return (
		<>
			<h1 className='max-w-[400px] text-4xl font-bold'>
				{t`Aucun espace n'est disponible avec les critères de recherche sélectionnés`}
			</h1>

			<p>{t`🔎 Modifiez vos filtres et/ou dézoomez dans la carte pour élargir votre recherche`}</p>

			<Button
				color='inherit'
				variant='outline'
				onClick={onResetSearch}
			>
				{t`Réinitialiser la recherche`}
			</Button>
		</>
	)
}

export const NoSpacesFound = memo(
	({
		hasAlternatives,
		className,
	}: {
		hasAlternatives?: boolean
		className?: string
	}) => {
		const { filters } = useSearchSpaces()

		return (
			<div
				data-testid='no-spaces-found'
				className={cn('flex flex-col items-start gap-6', className)}
			>
				{hasAlternatives && filters.start ? <NoResults /> : <ResetSearch />}
			</div>
		)
	},
)
